const API = "https://api.jesulaba.uk";
// const API = "https://notes-api.promavancer-account.workers.dev";
const SECRET = "mkeepnotes";

export const apiFetch = async (path, options = {}) => {
  return fetch(API + path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${SECRET}`,
      ...(options.headers || {}),
    },
  });
};
